import { Modal } from "antd";
import { BellOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import MondayButton from "../../commonComponents/MondayButton/MondayButton";
import { eventTracker } from "../../../utils/eventTracker";
import "./EnableBrowserPushModal.scss";

/**
 * Strong prompt for browser notifications. Can be snoozed ("Më vonë") so a
 * denied/default permission does not block the whole app.
 */
export default function EnableBrowserPushModal({
  open,
  permission,
  supported,
  onEnable,
  onCloseWhenGranted,
  onDismiss,
}) {
  const { isDarkMode } = useSelector((state) => state.usersList);
  const granted = permission === "granted";
  const denied = permission === "denied";

  const handleEnable = async () => {
    eventTracker("BrowserPush", "click", "Enable from force modal");
    const next = await onEnable?.();
    if (next === "granted") {
      onCloseWhenGranted?.();
    }
  };

  const handleDismiss = () => {
    eventTracker("BrowserPush", "click", "Snooze force modal");
    onDismiss?.();
  };

  return (
    <Modal
      open={open && supported && !granted}
      title={null}
      footer={null}
      closable
      maskClosable={false}
      keyboard
      onCancel={handleDismiss}
      centered
      width={480}
      classNames={{
        root: `enable-browser-push-modal ${isDarkMode ? "dark" : ""}`,
      }}
      destroyOnHidden
    >
      <div className="enable-browser-push-modal__body">
        <div className="enable-browser-push-modal__icon" aria-hidden>
          <BellOutlined />
        </div>
        <h2>Aktivizo njoftimet në shfletues</h2>
        <p className="enable-browser-push-modal__lead">
          Që të mos humbasësh njoftime të rëndësishme (orar, aprovime, mesazhe),
          lejo njoftimet e FlexHR në këtë shfletues.
        </p>

        {denied ? (
          <div className="enable-browser-push-modal__denied">
            <p>
              Njoftimet janë <strong>bllokuar</strong> për këtë faqe. Hap
              cilësimet e shfletuesit dhe lejo njoftimet për{" "}
              <strong>{typeof window !== "undefined" ? window.location.host : "këtë site"}</strong>,
              pastaj kliko përsëri.
            </p>
            <ol>
              <li>Kliko ikonën e kyçit / informacionit pranë adresës</li>
              <li>Gjej “Njoftimet” / “Notifications”</li>
              <li>Zgjidh “Lejo” / “Allow”</li>
              <li>Rifresko faqen nëse duhet</li>
            </ol>
          </div>
        ) : (
          <ul className="enable-browser-push-modal__benefits">
            <li>
              <CheckCircleOutlined /> Popup i dukshëm me titull dhe tekst të qartë
            </li>
            <li>
              <CheckCircleOutlined /> Mbërrin në kohë reale përmes WebSocket
            </li>
            <li>
              <CheckCircleOutlined /> Mund t’i menaxhosh nga ikona e ziles në header
            </li>
          </ul>
        )}

        <div className="enable-browser-push-modal__actions">
          <MondayButton
            className="mondayButtonBlue enable-browser-push-modal__cta"
            onClick={handleEnable}
            hasIcon
            Icon={<BellOutlined />}
          >
            {denied ? "Kontrollo përsëri lejen" : "Aktivizo njoftimet"}
          </MondayButton>
          <MondayButton
            className="mondayButtonGrey enable-browser-push-modal__later"
            onClick={handleDismiss}
          >
            Më vonë
          </MondayButton>
        </div>
      </div>
    </Modal>
  );
}
